import React from 'react';
import { uxAnalyticsUtil } from '../../utils';
import { useDispatch } from 'react-redux';
import useOutsideClick from '../../hooks/useOutsideClick';
import {
  UPDATE_SEARCH_TERM,
  UPDATE_OPPORTUNITIES_LIST
} from '../../modules/betaOpportunities';
import { useHistory } from 'react-router';
import styled from 'styled-components';

const GenreSurface = styled.div`
  background: ${({theme}) => theme.background?.primary || 'var(--br-surface)'};
  color: ${({theme}) => theme.font?.primary || 'var(--br-text)'};
  min-height: 100%;
`;

const GenreColumns = styled.div`
  display: grid;
  gap: var(--br-space-3);
  grid-template-columns: repeat(5, minmax(0, 1fr));

  @media (max-width: 900px) { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  @media (max-width: 600px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
`;

const GenreList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const GenreLink = styled.button`
  background: transparent;
  border: 0;
  border-radius: var(--br-control-radius);
  color: ${({theme}) => theme.font?.primary || 'var(--br-text)'};
  cursor: pointer;
  font: inherit;
  padding: var(--br-space-2) var(--br-space-3);
  text-align: left;
  width: 100%;

  &:hover {
    background: var(--br-hover-surface);
    color: ${({theme}) => theme.navigation?.accent || 'var(--br-accent)'};
  }
  &:focus-visible { outline: 2px solid var(--br-focus); outline-offset: 2px; }
`;

export const GenreGrid = ({ genres = [], onClose }) => {
  const gridRef = React.useRef();
  const history = useHistory();
  const dispatch = useDispatch();

  useOutsideClick(gridRef, () => onClose?.());

  const selectedDimension = React.useCallback(genre => {
    uxAnalyticsUtil.trackEvent({
      category: 'Discover',
      action: `clicked-genre-${genre}`,
      label: 'browse'
    });
    onClose?.();
    dispatch({ type: UPDATE_SEARCH_TERM, searchTerm: '' });
    dispatch({ type: UPDATE_OPPORTUNITIES_LIST, books: [] });
    history.push(`/discover/genre/${genre}`);
  }, [dispatch, history, onClose]);

  const columns = [
    genres.slice(0, 15),
    genres.slice(15, 30),
    genres.slice(30, 45),
    genres.slice(45, 60),
    genres.slice(60)
  ];

  return (
    <GenreSurface ref={gridRef}>
      <GenreColumns>
        {columns.map((column, index) => (
          <GenreList key={index}>
            {column.map((genre, genreIndex) => (
              <li key={`${genreIndex}-${genre}`}>
                <GenreLink type='button' onClick={() => selectedDimension(genre)}>{genre}</GenreLink>
              </li>
            ))}
          </GenreList>
        ))}
      </GenreColumns>
    </GenreSurface>
  );
};

export default GenreGrid;
